import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import styled from "styled-components";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/styles";
import PulseLoader from "react-spinners/PulseLoader"
import { topics_completed_in_a_topic_group } from "../../services/CertificationsAPI";

const theme = localStorage.getItem("brandColor");

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--cell": {
      backgroundColor: "rgba(224, 183, 60, 0.55)",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app.negative": {
      backgroundColor: "rgba(157, 255, 118, 0.49)",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app.positive": {      
      border: "1px solid #ff8c24",
      color: "#1a3e72",
      fontWeight: "600",
    },
    "& .super-app-theme--header": {
      color: "#FFFFFF",
      fontWeight: "600",
    },
  },
});

const StyledButton = styled.button`
  background: ${theme};
  width: 200px;
  border-radius: 30px;
  height: 45px;
  text-align: center;
  color: white;
  font-size: 16px !important;
  font-weight: 500;
  border-color: none;
  border: none;
  margin-top: 25px;
  padding: 5px 10px;
`;

const TopicsCompleted = () => {
    const classes = useStyles();    
    const history = useHistory()
    const params = useParams()   
    let [loading, setloading] = useState(true)
    const [completedTopics, setCompletedTopics] = useState([]);        

    useEffect(() => {       
        prepareInitialData() 
    }, []);

    const prepareInitialData = async () => {
        let result = await topics_completed_in_a_topic_group({customer_id: localStorage.getItem('customerid'), topgrpcode: params.topgrpcode})
        if(result){            
            setloading(false);
            console.log(result.data.topics_completed_in_a_topic_group)
            setCompletedTopics(result.data.topics_completed_in_a_topic_group);
        }
    }

    const completedTopicsColumns = [
        {
            field: "topgrpdesc",
            headerName: "Topic Group",
            flex: 1,
            align: "left",
            headerAlign: "center",
            headerClassName: "super-app-theme--header",
        },
        {
            field: "topicdesc",
            headerName: "Topic",
            flex: 1,
            align: "left",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        },       
        {
            field: "cntlastperiod",
            headerName: "Participating Locations",
            flex: 0.5,
            align: "center",
            headerAlign: "center",
            headerClassName: "super-app-theme--header"          
        }           
    ];
        
    return (
        loading ? 
        ( 
            <div style={{height: 'calc(100vh - 66px)'}} className="d-flex justify-content-center align-items-center">
                <PulseLoader size={10} color={theme} />
            </div> 
        ) 
        : 
        (
            <>
                <div className="container">
                    <div className="text-center">
                        <StyledButton
                            onClick={() => {
                                history.push("/certifications");
                            }}
                        >
                        Exit
                        </StyledButton>
                    </div>                    
                    <div className="mt-4">
                        <h4 className="text-center">Topics Completed in a Topic Group</h4>
                        <div style={{ height: "auto", width: "75%", margin: 'auto' }} className={classes.root}>
                            <DataGrid
                                sx={{
                                    ".MuiDataGrid-columnHeaders": {
                                        backgroundColor: theme,
                                    },
                                    "&.MuiDataGrid-root": {
                                        border: "none",
                                    },
                                }}
                                getRowId={(r) => r.id}
                                autoHeight      
                                onRowClick={(params) => {                                    
                                    history.push(`/topic_completed_by_location/${params.row.topicid}`);
                                }}                       
                                rows={completedTopics}                                
                                id="_id"                     
                                columns={completedTopicsColumns} 
                                hideFooterPagination={true}                       
                            />
                        </div>
                    </div>                               
                </div>
            </>
        )
    )
}


export default TopicsCompleted